<template>
  <v-container
    id="detalhe-principais-clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                >
                  <dashboard-filtro-datas
                    :primeiro="enablePrimeiroDia"
                    :ultimo="enableUltimoDia"
                    :empresas="enableEmpresa"
                    :supervisores="enableSupervisores"
                    :url="link"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-card
                        id="cardDashbord"
                        class="mx-auto"
                        outlined
                      >
                        <div class="card-header-dashbord">
                          <v-row>
                            <v-col
                              cols="12"
                              sm="9"
                              md="9"
                              lg="9"
                              class="d-flex flex-wrap"
                            >
                              Como está o faturamento dos meus grupos de itens?
                            </v-col>
                            <v-col
                              cols="1"
                            >
                              <v-btn
                                id="btnPrint"
                                class="col-12 lg-12"
                                small
                                :disabled="enableBtn"
                                :color="corPrimaria"
                                dark
                                @click="imprimir()"
                              >
                                <v-icon>
                                  mdi-printer
                                </v-icon>
                                Imprimir
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="2"
                              md="2"
                              lg="2"
                              class="d-flex justify-end"
                            >
                              <v-tooltip top>
                                <template
                                  v-slot:activator="{ on, attrs }"
                                >
                                  <v-icon
                                    id="iconInformationClientesFaturados"
                                    class="text-left"
                                    v-bind="attrs"
                                    v-on="on"
                                    @mouseover="enableTexto('317')"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <div
                                  v-if="codigo === '317'"
                                  v-html="textoDetalhesFatClassificacao"
                                />
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </div>
                        <v-card-actions>
                          <v-row v-if="loading">
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                :style="styleObject"
                                class="text-center"
                              >
                                <v-icon
                                  light
                                  class="custom-loader"
                                  :style="styleObject"
                                >
                                  mdi-cached
                                </v-icon>
                                Carregando dados...
                              </div>
                            </v-col>
                          </v-row>
                          <v-row v-else-if="error">
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                class="alert alert-danger"
                              >
                                {{ error }}
                              </div>
                            </v-col>
                          </v-row>
                          <v-row v-else>
                            <v-row
                              id="filtrosPrint"
                              class="hidden"
                            >
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                              >
                                <h3 class="text-center">
                                  Filtros Selecionados:
                                </h3>
                                <div class="text-center">
                                  Data Inicial: {{ dataInicialImpressao }}
                                </div>
                                <div class="text-center">
                                  Data Final: {{ dataFinalImpressao }}
                                </div>
                                <div
                                  v-if="select.length > 0"
                                  class="'text-center'"
                                >
                                  Empresas selecionadas:
                                  <ul class="no-list-style">
                                    <li
                                      v-for="empresa in select"
                                      :key="empresa"
                                    >
                                      {{ empresa.nomeExibicao }}
                                    </li>
                                  </ul>
                                </div>
                              </v-col>
                            </v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                id="idTable"
                                style="overflow-x: auto;"
                              >
                                <table
                                  style="width: 100%; color: black; border-collapse: collapse;"
                                  class="elevation-1"
                                  mobile-breakpoint="0"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Vendedor
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Classificação de Produto
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Faturamento
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Fat. Mês do Ano Anterior
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Variação de Fat. Anual
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Participação da Linha
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="item in faturamentoGrupoProdutos"
                                      :key="item.id"
                                    >
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left;"
                                      >
                                        {{ item.vendedor }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left;"
                                      >
                                        {{ item.grupo_produto }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.faturamento }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.faturamento_anterior }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.variacao_anual }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.participacao_grupo }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Vendas from '../../../../../services/vendas'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardFaturamentoGrupoProdutos',
    emits: ['atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      select: [],
      empresa: [],
      supervisorSelect: [],
      supervisor: [],
      menu: false,
      menu1: false,
      loading: false,
      error: null,
      dataInicialImpressao: false,
      dataFinalImpressao: false,
      enableFatPrinCliente: false,
      enableEvolucaoVendas: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisores: true,
      codigo: 0,
      orientacao: [],
      textoDetalhesFatClassificacao: '',
      headersGrupoProdutos: [
        { text: 'Vendedor', value: 'vendedor', width: '150px', class: 'black--text title' },
        { text: 'Classificação de Produto', value: 'grupo_produto', width: '200px', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '150px', align: 'right', class: 'black--text title' },
        { text: 'Fat. Mês do Ano Anterior', value: 'faturamento_anterior', width: '180px', align: 'right', class: 'black--text title' },
        { text: 'Variação de Fat. Anual', value: 'variacao_anual', width: '150px', align: 'right', class: 'black--text title' },
        { text: 'Participação da Linha', value: 'participacao_grupo', width: '150px', align: 'right', class: 'black--text title' },
      ],
      faturamentoGrupoProdutos: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableBtn: true,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        eventEmit.$emit('atualizar_texto', 'Vendas - Detalhe Grupo Produtos')

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoVendas'))
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisorSelect = supervisores

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.date)

        this.updateDate()
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() + 3, 0).toISOString().substr(0, 10)

        if (date > dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser maiores que 2 meses da data atual')

          var data = new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0).toISOString().substr(0, 10)

          const [year, month, day] = data.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1).toISOString().substr(0, 10)

        if (date < dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser menores que 2 meses da data atual')

          const [year, month, day] = dataLimite.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '317') {
            this.textoDetalhesFatClassificacao = this.orientacao[i].descricao
          }
        }
      },

      updateDate () {
        this.faturamentoGrupoProdutos = []

        this.formatarDatasImpressao()

        this.showDelhamentoFaturamentoClassificacaoProdutos()
      },

      imprimir () {
        var filtros = document.getElementById('filtrosPrint').innerHTML
        var conteudo = document.getElementById('headersGrupoProdutos').innerHTML

        var telaImpressao = window.open()

        var impressao = filtros + conteudo

        telaImpressao.document.write(impressao)
        telaImpressao.window.print()
        telaImpressao.window.close()
      },

      formatarDatasImpressao () {
        var partesInicial = this.primeiroDia.split('-')
        var ano = partesInicial[0]
        var mes = partesInicial[1]
        var dia = partesInicial[2]
        this.dataInicialImpressao = dia + '/' + mes + '/' + ano

        var partesFinal = this.ultimoDia.split('-')
        var anoFinal = partesFinal[0]
        var mesFinal = partesFinal[1]
        var diaFinal = partesFinal[2]
        this.dataFinalImpressao = diaFinal + '/' + mesFinal + '/' + anoFinal
      },

      async showDelhamentoFaturamentoClassificacaoProdutos () {
        this.loading = true
        this.enableBtn = true

        await Vendas.showDelhamentoClassificacaoProdutos(this.primeiroDia, this.ultimoDia, this.select, this.supervisorSelect, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.faturamentoGrupoProdutos = resposta.data.dadosExibicao.map((item) => {
              var listaFaturamento = ({
                vendedor: item.vendedor,
                grupo_produto: item.grupo_produto,
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamento_anterior: item.faturamento_anterior ? parseFloat(item.faturamento_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '',
                variacao_anual: item.variacao_anual ? parseFloat(item.variacao_anual).toFixed(2) + '%' : '',
                participacao_grupo: item.participacao_grupo ? parseFloat(item.participacao_grupo).toFixed(2) + '%' : '',
              })

              return listaFaturamento
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamentoGrupoProdutos = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }
</style>

<style lang="sass">
  #btnPrint
    margin: 0 0 0 9rem

  #relatorioClientesFaturados
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationClientesFaturados
    margin-left: 9.5rem
    font-weight: bold

  #headersClientesFaturados
    margin-left: 1.7rem
    margin-right: 1.7rem

  .no-list-style
    list-style-type: none
    padding: 0
    margin: 0

  .no-list-style li
    text-decoration: none

  .hidden
    display: none

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
